import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/lunar/Logo";
import { StoreButtons, STORE_LINKS } from "@/components/lunar/StoreButtons";

const isLiveStoreUrl = (url) => /^https?:\/\//.test(url);

export default function Download() {
    const [redirecting, setRedirecting] = useState(false);

    useEffect(() => {
        document.title = "Lunar — Download";

        const userAgent = navigator.userAgent || "";
        const isIOS =
            /iPad|iPhone|iPod/.test(userAgent) ||
            (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
        const isAndroid = /Android/i.test(userAgent);
        const target = isIOS
            ? STORE_LINKS.appStore
            : isAndroid
              ? STORE_LINKS.googlePlay
              : null;

        if (target && isLiveStoreUrl(target)) {
            setRedirecting(true);
            window.location.replace(target);
        }
    }, []);

    return (
        <div data-testid="smart-download-page" className="flex min-h-screen flex-col bg-[#F9F8F4] px-6 py-8 text-[#1D201A]">
            <Link to="/" aria-label="Lunar home" data-testid="smart-download-home-link" className="mx-auto">
                <Logo size={46} />
            </Link>
            <main className="flex flex-1 items-center justify-center py-16">
                <div className="max-w-xl text-center">
                    <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#899B6A]">
                        The social network for real life
                    </p>
                    <h1
                        data-testid="smart-download-title"
                        className="font-display mt-5 text-5xl font-medium leading-[1.08] tracking-tight text-[#1D201A] sm:text-6xl"
                    >
                        Download Lunar.
                    </h1>
                    <p
                        data-testid="smart-download-subtitle"
                        className="mx-auto mt-5 max-w-md text-base leading-relaxed text-[#5C5F58] sm:text-lg"
                    >
                        {redirecting ? "Taking you to your app store…" : "Choose your store below."}
                    </p>
                    <div className="mt-9 flex justify-center">
                        <StoreButtons
                            appStoreTestId="smart-download-app-store"
                            googlePlayTestId="smart-download-google-play"
                            centered
                            showQr={false}
                        />
                    </div>
                </div>
            </main>
        </div>
    );
}
